import { PropsWithChildren, useContext } from "react";
import { Tabs } from "@mui/material";
import { TabsReactContext } from "src/components-mui/tabs/tabs-context";
import { getTabsListCustomVariantStyles } from "src/components-mui/tabs/tabs-list.styles";

export interface ITabsListProps {
    customVariant?: "pills" | "full";
    /** `full` variant only: full width on mobile, sized to its content from `sm` up. */
    fitContent?: boolean;
    /** Controlled mode: overrides the value held by `TabsContext`. */
    value?: string | number;
    onChange?: (value: string | number) => void;
    "aria-labelledby"?: string;
}

const TABS_SLOTS = { indicator: () => null };

export const TabsList = ({
    children,
    customVariant,
    fitContent,
    value,
    onChange,
    "aria-labelledby": ariaLabelledBy,
}: PropsWithChildren<ITabsListProps>) => {
    const context = useContext(TabsReactContext);

    return (
        <Tabs
            value={value ?? context.currentTab}
            onChange={(_, newValue) => (onChange ?? context.setCurrentTab)(newValue)}
            aria-labelledby={ariaLabelledBy}
            slots={TABS_SLOTS}
            sx={getTabsListCustomVariantStyles(customVariant, fitContent)}
        >
            {children}
        </Tabs>
    );
};
